/**
 * Strip markdown link syntax (`[text](url)`) down to just the link text.
 * Useful for surfaces (toasts, etc.) that only accept plain strings.
 */
export const stripMarkdownLinks = (text: string): string =>
  text.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
